export default __webpack_public_path__ + "static/media/curved7.db9a96a3.jpg";